import { render, staticRenderFns } from "./CancelFlowCard.vue?vue&type=template&id=6e2a0dd1&"
import script from "./CancelFlowCard.vue?vue&type=script&lang=ts&"
export * from "./CancelFlowCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports